import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { cmmsEntityCategories } from '@app/pages/cmms/configs/cmms-entity-categories';
import { AuMapConstructClass } from '@shared/au-map-construct.class';
import { AuBodyTextModule } from '../au-body-text/au-body-text.module';
import { MatIconModule } from '@angular/material/icon';

import { TranslateService } from '@tolgee/ngx';
import { inject } from '@angular/core';

const valueLists = {
	workOrderCategories: new AuMapConstructClass(cmmsEntityCategories),
};

@Component({
	selector: 'au-key-value-text',
	template: ` <au-body-text [text]="getValueByKeyFromValueList"></au-body-text> `,

	imports: [MatIconModule, AuBodyTextModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuKeyValueComponent {
	@Input() key: string;
	@Input() valueListKey: string;
	private translateService = inject(TranslateService);

	get getValueByKeyFromValueList(): string {
		if (this.key && this.valueListKey) {
			return this.translateService.instant(
				valueLists[this.valueListKey].itemMap.get(this.key)
			);
		}
	}
}
